import React, { useEffect, useState } from 'react'
import { Table } from 'antd'
import { fetchAdminActivities, fetchNextAdminActivities } from '../../../firebase/utils'
import { Card, Container } from 'reactstrap'
import { Breadcrumbs, Btn } from '../../../AbstractElements'
import { useVT } from 'virtualizedtableforantd4'
import moment from 'moment'
import SeachBar from '../../UiKits/SearchBar'
import ActivityDetail from './ActivityDetail'
import { useLocation } from 'react-router'
import { addSearchParams, getSearchParams } from '../../../utils'

const AdminActivity = () => {
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [lastDoc, setlastDoc] = useState(null)
  const [activity, setActivity] = useState({
    show: false,
    details: null
  })
  const [adminActivities, setAdminActivities] = useState([])
  const location = useLocation();

  const openActivityDetails = (activity) => {
    addSearchParams(location, activity);
    setActivity({ show: true, details: activity });
  };

  const checkAndOpenDetails = () => {
    const { isOpenDetails, itemId } = getSearchParams(location);
    if (isOpenDetails && itemId) {
      const selectedItem = adminActivities.find((item) => item.id === itemId);
      if (selectedItem) {
        setActivity({ show: true, details: selectedItem });
      } else {
        setActivity({ show: false, details: null });
      }
    } else {
      setActivity({ show: false, details: null });
    }
  }

  useEffect(() => {
    checkAndOpenDetails();
  }, [location.search, adminActivities]);

  useEffect(() => {
    window.addEventListener("popstate", checkAndOpenDetails);
    return () => window.removeEventListener("popstate", checkAndOpenDetails);
  }, [adminActivities]);

  const debug = false
  const [vt] = useVT(
    () => ({
      onScroll: ({ isEnd }) => {
        if (isEnd) {
          fetchActivities('next')
        }
      },
      scroll: { y: 500 },
      debug,
    }),
    [lastDoc, adminActivities]
  );

  const activityTableColumn = [
    {
      title: "ADMIN EMAIL",
      dataIndex: "adminId",
    },
    {
      title: "USER EMAIL",
      dataIndex: "activityOnUser",
      render: (data) => data ? data : 'N/A'

    },
    {
      title: "TYPE",
      dataIndex: "functionName",
      dataIndex: "type",
    },
    {
      title: 'ACTIVITY DATE	',
      dataIndex: "createdAt",
      render: (data) => moment(data.seconds * 1000).format('LLL')
    },
    {
      title: 'OPEN ACTVITY',
      render: (activity) => <div style={{ display: 'grid', placeItems: "center" }}><Btn attrBtn={{ color: "primary", onClick: () => openActivityDetails(activity) }}>Open</Btn></div>
    },
  ]

  const fetchActivities = async (direction) => {
    if (direction === 'next') {
      const reports = await fetchNextAdminActivities(lastDoc)
      setAdminActivities([...adminActivities, ...reports.activities])
      setlastDoc(reports.lastDoc)
    } else {
      const reports = await fetchAdminActivities()
      setAdminActivities(reports.activities)
      setlastDoc(reports.lastDoc)
    }
    setLoading(false)
  }

  const filteredAdminActivities =
    adminActivities.filter((activity) => activity.adminId.toLowerCase().includes(search.toLowerCase()) || activity.activityOnUser?.toLowerCase().includes(search.toLowerCase()))

  useEffect(() => {
    fetchActivities()
  }, [])
  return (
    <>
      <Breadcrumbs mainTitle={'Admin Activities'} />
      <Container fluid={true} className="dashboard-default">
        <Card className='p-3'>
          <div className='bug-report-search'>
            <SeachBar search={search} setSearch={setSearch} />
          </div>
          <div style={{ marginBottom: '100px' }} className='ant-design-table not-margin'>
            <Table
              loading={loading}
              columns={activityTableColumn}
              dataSource={filteredAdminActivities}
              components={vt}
              bordered={true}
              pagination={false}

              scroll={{ y: 800 }}
            />
            {activity.show && <ActivityDetail activity={activity} setActivity={setActivity} />}
          </div>
        </Card>
      </Container>
    </>
  )
}

export default AdminActivity